const statementTableDictEN = {
  financial: "Financial",
  extracredit: "Extracredit",
  wallet: "Wallet",
  walletStatement: "Wallet statement",
  extracoinStatement: "Extracredit statement",
  extrabonusStatement: "Extrabonus Bonus Ads",
  bonusStatement: "Daily lifetime income statement",
  planNotAllowed: "Your current plan doesn't have access to this resource.",
  statementSubtitle: "Track operations performed on your wallet using Extracredit.",
  showingFirstToLast: "Showing {first} to {last} of {totalRecords}",
  noOperationsRecords: "Still no records of operations.",
  date: "Date",
  from: "From",
  toFrom: "To",
  check: "Check",
  statement: "Statement",
  description: "Description",
  inbound: "Inbound",
  outbound: "Outbound",
  status: "Status",
  dateTransaction: "Transaction Date",
  emptyDates: "Please choose a period of two dates.",
  completed: "Completed",
  pending: "Pending",
  pendingVoucher: "Pending voucher",
  canceled: "Canceled",
};

export default statementTableDictEN;
